var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBriefcaseSparkleBlackIcon = function SvgBriefcaseSparkleBlackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h29v26H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M-1676-1656c0-1.1.9-2 2-2H8376c1.1 0 2 .9 2 2v6368c0 1.1-.9 2-2 2H-1674c-1.1 0-2-.9-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-1674-1657H8376v-2H-1674zm10051 1v6368h2v-6368zm-1 6369H-1674v2H8376zm-10051-1v-6368h-2v6368zm1 1c-.55 0-1-.45-1-1h-2c0 1.66 1.34 3 3 3zm10051-1c0 .55-.45 1-1 1v2c1.66 0 3-1.34 3-3zm-1-6369c.55 0 1 .45 1 1h2c0-1.66-1.34-3-3-3zm-10050-2c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M-1338.5-758c0-12.979 10.52-23.5 23.5-23.5H699c12.979 0 23.5 10.521 23.5 23.5v957c0 12.979-10.521 23.5-23.5 23.5h-2014c-12.98 0-23.5-10.521-23.5-23.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M-1338.5-758c0-12.979 10.52-23.5 23.5-23.5H699c12.979 0 23.5 10.521 23.5 23.5v957c0 12.979-10.521 23.5-23.5 23.5h-2014c-12.98 0-23.5-10.521-23.5-23.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#briefcase-sparkle-black-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#briefcase-sparkle-black-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-36-195a4 4 0 0 1 4-4h340a4 4 0 0 1 4 4V34c0 6.627-5.373 12-12 12H-24c-6.627 0-12-5.373-12-12z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "briefcase-sparkle-black-icon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-36-16h348v52c0 5.523-4.477 10-10 10H-26c-5.523 0-10-4.477-10-10z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M-36-16h348v52c0 5.523-4.477 10-10 10H-26c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M-36-17h348v2H-36zm348 63H-36zm-348 0v-62zm348-62v62z",
    mask: "url(#briefcase-sparkle-black-icon_svg__c)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 169.5,
    height: 34.5,
    x: -15.25,
    y: -3.25,
    fill: "#fff",
    rx: 17.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 169.5,
    height: 34.5,
    x: -15.25,
    y: -3.25,
    stroke: "#222",
    strokeWidth: 1.5,
    rx: 17.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M7.5 7.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205q1.399.128 2.774.334c1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.7 24.7 0 0 1 12 17.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752v-3.033c0-1.434 1.022-2.7 2.476-2.917A49 49 0 0 1 7.5 7.455zm7.5 0v.09a50 50 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5m-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M3 20.4v-2.796a4.3 4.3 0 0 0 .713.31A26.2 26.2 0 0 0 12 19.25c2.892 0 5.68-.468 8.287-1.335q.378-.127.713-.311V20.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49 49 0 0 1-6.477-.427C4.047 23.128 3 21.852 3 20.4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "briefcase-sparkle-black-icon_svg__d",
    width: 15,
    height: 15,
    x: 13.646,
    y: -0.47,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.646-.47h15v15h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.193 2.042a.637.637 0 0 0-1.25 0l-.152.76a.64.64 0 0 1-.5.5l-.76.152a.637.637 0 0 0 0 1.25l.76.151c.253.05.45.248.5.5l.152.76a.637.637 0 0 0 1.25 0l.152-.76a.64.64 0 0 1 .5-.5l.76-.152a.637.637 0 0 0 0-1.25l-.76-.151a.64.64 0 0 1-.5-.5zM19.437 4.514a.637.637 0 0 0-1.209 0l-.436 1.308a.64.64 0 0 1-.403.403l-1.307.435a.637.637 0 0 0 0 1.21l1.307.435c.19.064.34.213.403.403l.436 1.307a.637.637 0 0 0 1.21 0l.435-1.307a.64.64 0 0 1 .403-.403l1.307-.436a.637.637 0 0 0 0-1.209l-1.307-.435a.64.64 0 0 1-.403-.403zM23.898 9.612a.637.637 0 0 0-1.21 0l-.116.352a.64.64 0 0 1-.403.403l-.352.117a.637.637 0 0 0 0 1.209l.352.117c.19.063.34.213.403.403l.117.351a.637.637 0 0 0 1.209 0l.117-.351a.64.64 0 0 1 .403-.403l.352-.117a.637.637 0 0 0 0-1.21l-.352-.116a.64.64 0 0 1-.403-.403z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M25.193 2.042a.637.637 0 0 0-1.25 0l-.152.76a.64.64 0 0 1-.5.5l-.76.152a.637.637 0 0 0 0 1.25l.76.151c.253.05.45.248.5.5l.152.76a.637.637 0 0 0 1.25 0l.152-.76a.64.64 0 0 1 .5-.5l.76-.152a.637.637 0 0 0 0-1.25l-.76-.151a.64.64 0 0 1-.5-.5zM19.437 4.514a.637.637 0 0 0-1.209 0l-.436 1.308a.64.64 0 0 1-.403.403l-1.307.435a.637.637 0 0 0 0 1.21l1.307.435c.19.064.34.213.403.403l.436 1.307a.637.637 0 0 0 1.21 0l.435-1.307a.64.64 0 0 1 .403-.403l1.307-.436a.637.637 0 0 0 0-1.209l-1.307-.435a.64.64 0 0 1-.403-.403zM23.898 9.612a.637.637 0 0 0-1.21 0l-.116.352a.64.64 0 0 1-.403.403l-.352.117a.637.637 0 0 0 0 1.209l.352.117c.19.063.34.213.403.403l.117.351a.637.637 0 0 0 1.209 0l.117-.351a.64.64 0 0 1 .403-.403l.352-.117a.637.637 0 0 0 0-1.21l-.352-.116a.64.64 0 0 1-.403-.403z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.047,
    d: "M25.193 2.042a.637.637 0 0 0-1.25 0l-.152.76a.64.64 0 0 1-.5.5l-.76.152a.637.637 0 0 0 0 1.25l.76.151c.253.05.45.248.5.5l.152.76a.637.637 0 0 0 1.25 0l.152-.76a.64.64 0 0 1 .5-.5l.76-.152a.637.637 0 0 0 0-1.25l-.76-.151a.64.64 0 0 1-.5-.5zM19.437 4.514a.637.637 0 0 0-1.209 0l-.436 1.308a.64.64 0 0 1-.403.403l-1.307.435a.637.637 0 0 0 0 1.21l1.307.435c.19.064.34.213.403.403l.436 1.307a.637.637 0 0 0 1.21 0l.435-1.307a.64.64 0 0 1 .403-.403l1.307-.436a.637.637 0 0 0 0-1.209l-1.307-.435a.64.64 0 0 1-.403-.403zM23.898 9.612a.637.637 0 0 0-1.21 0l-.116.352a.64.64 0 0 1-.403.403l-.352.117a.637.637 0 0 0 0 1.209l.352.117c.19.063.34.213.403.403l.117.351a.637.637 0 0 0 1.209 0l.117-.351a.64.64 0 0 1 .403-.403l.352-.117a.637.637 0 0 0 0-1.21l-.352-.116a.64.64 0 0 1-.403-.403z",
    mask: "url(#briefcase-sparkle-black-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#512ACC",
    strokeWidth: 0.8,
    d: "M-35.6-195a3.6 3.6 0 0 1 3.6-3.6h340a3.6 3.6 0 0 1 3.6 3.6V34c0 6.407-5.194 11.6-11.6 11.6H-24c-6.407 0-11.6-5.193-11.6-11.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "briefcase-sparkle-black-icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-36-195a4 4 0 0 1 4-4h340a4 4 0 0 1 4 4V34c0 6.627-5.373 12-12 12H-24c-6.627 0-12-5.373-12-12z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "briefcase-sparkle-black-icon_svg__a",
    width: 368,
    height: 265,
    x: -42,
    y: -205,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45149_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_45149_2",
    result: "shape"
  })))));
};
export default SvgBriefcaseSparkleBlackIcon;